import { useState, useEffect } from "react";

const EXPIRATION_DATE = new Date("2025-05-19T16:40:00");

export const useWelcomePopup = () => {
  const [showWelcome, setShowWelcome] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const hasSeenWelcome = sessionStorage.getItem("hasSeenWelcome");
    const currentDate = new Date();

    // Mostra il popup solo se non è stato mai visto E non è scaduto
    if (!hasSeenWelcome && currentDate < EXPIRATION_DATE) {
      setAnchorEl(document.body);
      setShowWelcome(true);
      sessionStorage.setItem("hasSeenWelcome", "true");
    }
  }, []);

  const handleCloseWelcome = () => {
    setShowWelcome(false);
  };

  return {
    showWelcome,
    anchorEl,
    handleCloseWelcome,
  };
};